<template>
  <div class="column-view">
    <div v-if="list.length > 0" class="margin-bottom-10">
      <el-button @click="exportExcel()" icon="el-icon-download" type="primary"
        >导出EXCEL</el-button
      >
    </div>
    <el-table :data="list" v-loading="loading" ref="table">
      <el-table-column label="局管领导干部政治素质测评结果汇总" align="center">
        <el-table-column
          label="部门/职务"
          width="250px"
          align="center"
          prop="remark"
        >
        </el-table-column>
        <el-table-column label="姓名" width="100px" align="center">
          <template slot-scope="scope">
            {{ scope.row.employee.name }}
          </template>
        </el-table-column>
        <el-table-column label="测评人数" align="center">
          <el-table-column label="合计" width="100px" align="center">
            <template slot-scope="scope">
              {{
                Number(scope.row.join_first_meeting_number) +
                Number(scope.row.join_second_meeting_number)
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="山西局年度考核述职测评会"
            width="100px"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.join_first_meeting_number || "" }}
            </template>
          </el-table-column>
          <el-table-column
            label="部门（单位）考核述职测评会"
            width="100px"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.join_second_meeting_number || "" }}
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="好" align="center">
          <el-table-column
            label="票数"
            width="150px"
            align="center"
            prop="excellent_count"
          >
          </el-table-column>
          <el-table-column label="比例" width="200px" align="center">
            <template slot-scope="scope">
              {{
                scope.row.excellent_rate ? scope.row.excellent_rate + "%" : ""
              }}
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="较好" align="center">
          <el-table-column
            label="票数"
            width="150px"
            align="center"
            prop="good_count"
          >
          </el-table-column>
          <el-table-column label="比例" width="200px" align="center">
            <template slot-scope="scope">
              {{ scope.row.good_rate ? scope.row.good_rate + "%" : "" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="一般" align="center">
          <el-table-column
            label="票数"
            width="150px"
            align="center"
            prop="average_count"
          >
          </el-table-column>
          <el-table-column label="比例" width="200px" align="center">
            <template slot-scope="scope">
              {{ scope.row.average_rate ? scope.row.average_rate + "%" : "" }}
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="较差" align="center">
          <el-table-column
            label="票数"
            width="150px"
            align="center"
            prop="poor_count"
          >
          </el-table-column>
          <el-table-column label="比例" width="200px" align="center">
            <template slot-scope="scope">
              {{ scope.row.poor_rate ? scope.row.poor_rate + "%" : "" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="弃权" align="center">
          <el-table-column
            label="票数"
            width="100px"
            align="center"
            prop="abstain_number"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="评价结果分值"
          width="150px"
          align="center"
          prop="vote_result_txt"
        >
        </el-table-column>
      </el-table-column>
      <template #empty>
        <yc-no-content des="暂未生成数据汇总表"></yc-no-content>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "thirdTable",
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  methods: {
    showLoading() {
      this.loading = true;
    },
    setData(list) {
      console.log("设置数据了");
      this.list = list;
      this.loading = false;
    },
    getPercentage(a, b) {
      if (b === 0) return "0.0%"; // 避免除以 0
      return ((a / b) * 100).toFixed(1) + "%";
    },

    exportExcel() {
      this.$commonUtils.exportExcel(
        this.$refs.table,
        "局管领导干部政治专项测评"
      );
    },
  },
};
</script>

<style scoped></style>
